<div class="metadata-view-navigation-list">
    <div ngModelGroup="menuView">
        @if (hasMenuView) {
        <metadata-view layout-fill [view]="menuView" [model]="model" [viewOnly]="viewOnly"
            [datacontroller]="datacontroller" [isMenu]="true">
        </metadata-view>
        }
        @if (hasMenuView) {
        <forge-divider style="padding: .5rem 0;"></forge-divider>
        }
        @if (hasShortcuts) {
        <forge-select #shortcut class="dense-input metadata-padding" aria-label="Form Menu Shortcut"
            (change)="goToView($event.detail)" dense placeholder="Shortcuts...">
            @for (shortcutView of shortcutViews; track shortcutView) {
            <forge-option [value]="shortcutView">{{shortcutView.label}}</forge-option>
            }
        </forge-select>
        }
        <metadata-navigation-tree [nodes]="nodes" (onClick)="select($event)" (onContextMenu)="context($event)">
        </metadata-navigation-tree>
    </div>
</div>